//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.BoundaryMemberSetList.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectTaggedObject.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"BoundaryMemberList",0,"CAM.BoundaryMemberSetList",0],[0,"BoundaryType",1,0],[0,"CustomOffset",1,0],[0,"Offset",1,0],[0,"OffsetIntent",1,0],[0,"Plane",1,"Plane",0],[0,"PlaneType",1,0],[1,"PointList",0,"SelectTaggedObjectList",0],[1,"SelectObject",0,"SelectTaggedObject",0],[0,"ToolPosition",1,0],[0,"ToolSide",1,0]],[[["curves","pickPoint","matrix"],"AppendCurves",{},3,0],[["curves"],"RemoveCurves",{},1,0],[[],"CreateBoundaryMemberSet",{R_:{bndSet:"CAM.BoundaryMemberSet"}},0,0],[["sourceSet"],"SynchronizePlanes",{},1,0]],[]];
SPLM.CAM.BoundarySet = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BoundarySet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BoundarySet.BoundaryTypes = Object.freeze({
    "Closed" : "Closed", "Open" : "Open"});

SPLM.CAM.BoundarySet.ToolSideTypes = Object.freeze({
    "InsideOrLeft" : "InsideOrLeft", "OutsideOrRight" : "OutsideOrRight"});

SPLM.CAM.BoundarySet.PlaneTypes = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

SPLM.CAM.BoundarySet.ToolPositionTypes = Object.freeze({
    "On" : "On", "Contact" : "Contact"});

export default SPLM;